import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import EmojiPicker from "emoji-picker-react";
import { formatarDataBrasil } from "../utils/utils";
import "./ListagemAcoes.css";

function ListagemAcoes() {
  const navigate = useNavigate();

  // ---- dados da listagem / filtros ----
  const [acoes, setAcoes] = useState([]);
  const [filters, setFilters] = useState({
    nome: "",
    telefone: "",
    status: "",
    data_inicio: "",
    data_fim: "",
  });
  const [sortConfig, setSortConfig] = useState({ key: "lead_nome", direction: "asc" });

  // ---- seleção de leads + envio em massa (copiado do ListagemLeads) ----
  const [leadsSelecionados, setLeadsSelecionados] = useState([]); // array de lead_id
  const [mensagemFila, setMensagemFila] = useState("");
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [delaySegundos, setDelaySegundos] = useState(5);
  const [dataAgendamento, setDataAgendamento] = useState("");
  const [horaAgendamento, setHoraAgendamento] = useState("");
  const [mostrarEmojiPicker, setMostrarEmojiPicker] = useState(false);
  const [arquivoUrl, setArquivoUrl] = useState("");
  const [tipoMidia, setTipoMidia] = useState("");
  const [uploadEmAndamento, setUploadEmAndamento] = useState(false);
  const msgRef = useRef(null);
  // respostas rápidas (mesma mecânica do Painel)
  const [rrVisivel, setRrVisivel] = useState(false);
  const [rrLista, setRrLista] = useState([]);
  const [rrFiltro, setRrFiltro] = useState('');
  const [rrIndex, setRrIndex] = useState(0);
  const rrRef = useRef(null);

  

  const insertToken = (token) => {
    setMensagemFila((prev) => {
      const el = msgRef.current;
      if (!el || typeof el.selectionStart !== "number") return prev + token;
      const start = el.selectionStart;
      const end = el.selectionEnd;
      const next = prev.slice(0, start) + token + prev.slice(end);
      requestAnimationFrame(() => {
        try { el.focus(); const pos = start + token.length; el.setSelectionRange(pos, pos); } catch {}
      });
      return next;
    });
  };

  const buscarRespostasRapidas = async (q = '') => {
  try {
    const url = q
      ? `/crm-wly/api/whatsapp/respostas_rapidas.php?q=${encodeURIComponent(q)}`
      : `/crm-wly/api/whatsapp/respostas_rapidas.php`;
    const res = await fetch(url, { credentials: 'include' });
    const data = await res.json();
    if (data.success && Array.isArray(data.data)) setRrLista(data.data);
    else setRrLista([]);
  } catch {
    setRrLista([]);
  }
};


  const tokenBtnStyle = {
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    height: 24, padding: "2px 8px", fontSize: 12, lineHeight: 1, borderRadius: 6,
    color: "white", border: "1px solid #d0d0d0", background: "#c7c7c7", cursor: "pointer",
    whiteSpace: "nowrap"
  };

  const agendado_em = (dataAgendamento && horaAgendamento)
    ? `${dataAgendamento} ${horaAgendamento}:00`
    : null;

  const handleEnviarFila = async () => {
    if (!mensagemFila.trim() && !arquivoUrl) {
      alert("Digite uma mensagem ou anexe um arquivo para enviar.");
      return;
    }
    try {
      setEnviando(true);
      const res = await fetch("/crm-wly/api/whatsapp/criar_fila_zapi.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          lead_ids: leadsSelecionados,      // << envia por lead_id
          mensagem: mensagemFila,
          tipo_midia: tipoMidia || null,
          midia_url: arquivoUrl || null,
          delay_envio: delaySegundos,
          agendado_em
        })
      });
      const data = await res.json();
      if (data.success) {
        alert("Mensagens adicionadas à fila com sucesso!");
        setMostrarPopup(false);
        setLeadsSelecionados([]);
        setMensagemFila("");
        setArquivoUrl("");
        setTipoMidia("");
      } else {
        alert("Erro ao adicionar na fila: " + (data.message || ""));
      }
    } catch (err) {
      console.error(err);
      alert("Erro ao enviar mensagens.");
    } finally {
      setEnviando(false);
    }
  };

  const toggleLeadSelecionado = (leadId) => {
    setLeadsSelecionados((prev) =>
      prev.includes(leadId) ? prev.filter((id) => id !== leadId) : [...prev, leadId]
    );
  };

  const toggleTodosLeads = () => {
    const allLeadIds = Array.from(new Set(sortedAcoes.map((a) => a.lead_id)));
    if (leadsSelecionados.length === allLeadIds.length) {
      setLeadsSelecionados([]);
    } else {
      setLeadsSelecionados(allLeadIds);
    }
  };

  // ---- busca ----
  useEffect(() => { fetchAcoes(); }, []); // carregar inicialmente

  const fetchAcoes = async () => {
    try {
      const onlyDigits = (s) => (s || "").replace(/\D/g, "");
      const query = new URLSearchParams({
        ...filters,
        telefone: onlyDigits(filters.telefone),
      }).toString();

      const response = await fetch(
        `https://welaunchyou.com.br/crm-wly/listagem_acoes.php?${query}`,
        { credentials: "include" }
      );
      const data = await response.json();
      setAcoes(data.acoes || []);
    } catch (error) {
      console.error("Erro ao buscar ações:", error);
      setAcoes([]);
    }
  };

  const handleFilterChange = (e) => setFilters({ ...filters, [e.target.name]: e.target.value });
  const handleFilterSubmit = (e) => { e.preventDefault(); fetchAcoes(); };

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const sortedAcoes = [...acoes].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "asc" ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const totalExibidas = sortedAcoes.length;
  const allLeadIdsOnScreen = Array.from(new Set(sortedAcoes.map(a => a.lead_id)));
  const allSelectedOnScreen = leadsSelecionados.length > 0 &&
                              leadsSelecionados.length === allLeadIdsOnScreen.length;

  return (
    <div className="acoes-container">
      <h1>Listagem de Ações</h1>

      {/* filtros */}
      <form className="filter-form" onSubmit={handleFilterSubmit}>
        <div className="form-group">
          <label htmlFor="nome">Nome do Lead:</label>
          <input id="nome" name="nome" value={filters.nome} onChange={handleFilterChange} />
        </div>

        <div className="form-group">
          <label htmlFor="telefone">Telefone:</label>
          <input
            id="telefone" name="telefone" type="tel"
            value={filters.telefone}
            onChange={handleFilterChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="status">Status:</label>
          <select id="status" name="status" value={filters.status} onChange={handleFilterChange}>
            <option value="">Todos</option>
            <option value="Pendente">Pendente</option>
            <option value="Concluída">Concluída</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="data_inicio">Data Início:</label>
          <input type="date" id="data_inicio" name="data_inicio"
                 value={filters.data_inicio} onChange={handleFilterChange}/>
        </div>

        <div className="form-group">
          <label htmlFor="data_fim">Data Fim:</label>
          <input type="date" id="data_fim" name="data_fim"
                 value={filters.data_fim} onChange={handleFilterChange}/>
        </div>

        <div><button style={{ marginTop: 30 }} type="submit">Filtrar</button></div>
      </form>

      {/* barra acima da tabela */}
      <div style={{ margin: "12px 0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        {leadsSelecionados.length > 0 ? (
          <div style={{ fontWeight: 600 }}>{leadsSelecionados.length} selecionado(s)</div>
        ) : <div />}
        <div style={{ opacity: 0.9 }}>
          {totalExibidas} ação{totalExibidas === 1 ? "" : "es"} exibida{totalExibidas === 1 ? "" : "s"}
        </div>
      </div>

      {/* resultado */}
      {sortedAcoes.length === 0 ? (
        <div className="empty-state-acoes">Nenhuma ação encontrada.</div>
      ) : (
        <table className="listagem-acoes-table">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={allSelectedOnScreen}
                  onChange={toggleTodosLeads}
                />
              </th>
              <th>ID</th>
              <th onClick={() => handleSort("lead_nome")} style={{ cursor: "pointer" }}>
                Lead {sortConfig.key === "lead_nome" ? (sortConfig.direction === "asc" ? "🔼" : "🔽") : ""}
              </th>
              <th>Descrição</th>
              <th>Data da Ação</th>
              <th>Status</th>
              <th>WhatsApp</th>
              <th>Ações</th>
            </tr>
          </thead>

          <tbody>
            {sortedAcoes.map((acao) => (
              <tr key={acao.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={leadsSelecionados.includes(acao.lead_id)}
                    onChange={() => toggleLeadSelecionado(acao.lead_id)}
                  />
                </td>
                <td>{acao.id}</td>
                <td>{acao.lead_nome}</td>
                <td>{acao.descricao}</td>
                <td>{formatarDataBrasil(acao.data_acao)}</td>
                <td>{acao.status}</td>
                <td>
                  <Link
                    to={`/wzp/painel-mensagens?telefone=${encodeURIComponent(acao.telefone)}&leadId=${acao.lead_id}`}
                    className="button-wzp"
                  >
                    {acao.telefone}
                  </Link>
                </td>
                <td>
                  <button
                    className="button button--edit"
                    onClick={() => navigate(`/editar-acao/${acao.id}`)}
                  >
                    Editar
                  </button>

                  <button
                    className="status-button"
                    onClick={async () => {
                      const formData = new FormData();
                      formData.append("acao_id", acao.id);
                      formData.append("novo_status", acao.status === "Pendente" ? "Concluída" : "Pendente");
                      const res = await fetch("https://welaunchyou.com.br/crm-wly/listagem_acoes.php", {
                        method: "POST", body: formData, credentials: "include",
                      });
                      const r = await res.json();
                      if (r.success) fetchAcoes();
                    }}
                  >
                    {acao.status === "Pendente" ? "Concluir" : "Pender"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* botão flutuante quando houver seleção */}
      {leadsSelecionados.length > 0 && (
        <button className="botao-flutuante-wzp" onClick={() => setMostrarPopup(true)}>
          <img src="https://cdn-icons-png.flaticon.com/512/733/733585.png" alt="WhatsApp" />
          Enviar Mensagem
        </button>
      )}

      {/* popup de confirmação */}
      {mostrarPopup && (
        <div className="popup-backdrop">
          <div className="popup-content">
            <h3>Confirme a mensagem</h3>
            <p>
              <strong>{leadsSelecionados.length}</strong> contato(s) selecionado(s).
            </p>

            {/* textarea + emoji */}
            <div style={{ position: "relative", marginBottom: 12, paddingBottom: 8 }}>
              <textarea
                ref={msgRef}
                value={mensagemFila}
                onChange={async (e) => {
                  const txt = e.target.value;
                  setMensagemFila(txt);

                  const cursor = e.target.selectionStart || txt.length;
                  const ateCursor = txt.slice(0, cursor);
                  const match = ateCursor.match(/\/([\w-]*)$/); // igual ao Painel

                  if (match) {
                    const termo = match[1] || '';
                    setRrFiltro(termo);
                    setRrVisivel(true);
                    setRrIndex(0);
                    await buscarRespostasRapidas(termo);
                  } else {
                    setRrVisivel(false);
                  }
                }}
                onKeyDown={(e) => {
                  if (!rrVisivel) return;

                  if (e.key === 'ArrowDown') { e.preventDefault(); setRrIndex(i => Math.min(i + 1, rrLista.length - 1)); }
                  if (e.key === 'ArrowUp')   { e.preventDefault(); setRrIndex(i => Math.max(i - 1, 0)); }
                  if (e.key === 'Escape')    { setRrVisivel(false); }
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    const item = rrLista[rrIndex];
                    if (!item) return;
                    setMensagemFila(prev => prev.replace(/\/[\w-]*$/, item.conteudo));
                    setRrVisivel(false);
                  }
                }}
                rows={6}
                placeholder='Digite a mensagem (use "/" para respostas rápidas)'
                style={{
                  width: "100%", boxSizing: "border-box", borderRadius: 8,
                  padding: "12px 44px 12px 12px", fontSize: 15,
                  border: "1px solid #ccc", backgroundColor: "#ece5dd",
                }}
              />

              {rrVisivel && rrLista.length > 0 && (
  <div ref={rrRef} className="rr-popup" style={{ position: 'absolute', top: '100%', left: 0, zIndex: 1000, width: '100%' }}>
    {rrLista.map((r, i) => (
      <div
        key={r.id}
        onMouseDown={(ev) => {
          ev.preventDefault(); // não perder foco do textarea
          setMensagemFila(prev => prev.replace(/\/[\w-]*$/, r.conteudo));
          setRrVisivel(false);
        }}
        style={{
          padding: '10px 12px',
          cursor: 'pointer',
          background: i === rrIndex ? '#f3f6ff' : '#fff',
          border: '1px solid #eee',
          borderTop: 'none'
        }}
      >
        <div style={{ fontWeight: 600 }}>{r.atalho} — {r.titulo}</div>
        <div style={{ fontSize: 12, color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {r.conteudo}
        </div>
      </div>
    ))}
  </div>
)}

              <button
                type="button"
                onClick={() => setMostrarEmojiPicker((prev) => !prev)}
                style={{ position: "absolute", bottom: 12, right: 12, background: "none", border: "none",
                         fontSize: 20, lineHeight: 1, cursor: "pointer" }}
                aria-label="Inserir emoji"
              >
                😊
              </button>
              {mostrarEmojiPicker && (
                <div style={{ position: "absolute", top: "100%", right: 0, zIndex: 1000 }}>
                  <EmojiPicker
                    onEmojiClick={({ emoji }) => {
                      setMensagemFila((prev) => prev + emoji);
                      setMostrarEmojiPicker(false);
                    }}
                    autoFocusSearch={false}
                    height={350}
                    width={300}
                    theme="light"
                  />
                </div>
              )}
            </div>

            {/* variáveis */}
            <div className="popup-mensagem-wzp">
              <span style={{ fontSize: 12, opacity: 0.8 }}>Variáveis:</span>
              <button type="button" onClick={() => insertToken("{primeiro_nome}")} style={tokenBtnStyle}>
                {"{primeiro_nome}"}
              </button>
              <button type="button" onClick={() => insertToken("{nome}")} style={tokenBtnStyle}>
                {"{nome}"}
              </button>
              <p>
                Clique e insira a variável. Ex.: “Olá <code>{'{primeiro_nome}'}</code>” vira
                “Olá Danton/Beatriz…”.
              </p>
            </div>

            {/* upload */}
            <div className="form-group" style={{ marginBottom: 16 }}>
              <label htmlFor="fileUpload">Anexar arquivo (imagem, PDF, áudio, vídeo):</label>
              <input
                id="fileUpload"
                type="file"
                accept="image/*,.pdf,audio/*,video/*"
                onChange={async (e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  const formData = new FormData();
                  formData.append("arquivo", file);
                  setUploadEmAndamento(true);
                  try {
                    const res = await fetch("/crm-wly/api/whatsapp/upload_temp.php", {
                      method: "POST", body: formData, credentials: "include",
                    });
                    const data = await res.json();
                    if (data.success) {
                      setArquivoUrl(data.url);
                      setTipoMidia(data.tipo_midia);
                      alert("Arquivo pronto para envio em massa.");
                    } else {
                      alert("Erro ao processar o arquivo: " + (data.message || ""));
                    }
                  } catch (err) {
                    console.error(err);
                    alert("Erro ao enviar arquivo.");
                  } finally {
                    setUploadEmAndamento(false);
                  }
                }}
              />
            </div>

            {/* agendamento */}
            <div className="agendamento-section">
              <label>Agendar envio para:</label>
              <div style={{ display: "flex", gap: 10 }}>
                <input type="date" value={dataAgendamento} onChange={(e) => setDataAgendamento(e.target.value)} />
                <input type="time" value={horaAgendamento} onChange={(e) => setHoraAgendamento(e.target.value)} />
              </div>
            </div>

           {/* delay */}
<div className="delay-section">
  <label htmlFor="delayInput">Tempo entre mensagens:</label>

  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <input
      id="delayInput"
      type="number"
      min="3"
      step="1"
      value={delaySegundos}
      onChange={(e) => {
        const valor = Number(e.target.value);
        setDelaySegundos(valor >= 3 ? valor : 3);
      }}
      style={{
        padding: "6px 10px",
        borderRadius: 6,
        border: "1px solid #ccc",
        fontSize: 14,
        width: 100
      }}
    />

    <span>segundos</span>
  </div>
</div>

<div className="alerta-delay">
  ⚠️ Intervalos muito curtos aumentam o risco de bloqueio do número de WhatsApp.
</div>

<div className="botoes-envio">
  <button onClick={() => setMostrarPopup(false)} className="cancelar">
    Cancelar
  </button>

  <button
    onClick={handleEnviarFila}
    className="confirmar"
    disabled={enviando || uploadEmAndamento}
  >
    {uploadEmAndamento
      ? "Aguardando upload..."
      : enviando
      ? "Enviando..."
      : "Confirmar Envio"}
  </button>
</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ListagemAcoes;
